// extracted by mini-css-extract-plugin
export default {"productGrid":"U4-z","centerLink":"V4-z","productSection":"W4-z","item":"X4-z","ctaButton":"Y4-z"};